import React, { useState, useEffect, useRef } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/input.scss'

function Element({ inputProps = [], groupKey, className, inputChange = () => {} }) {
  const inputRef = useRef([])
  const [inputState, setInputState] = useState(inputProps.map(({ value }) => value))

  const handleChange = (index, value) => {
    const oldState = [...inputState]
    oldState[index] = value
    setInputState(oldState)
    inputChange(groupKey, inputState)
  }

  return (
    <ul className={className} key={groupKey}>
      {inputProps?.map(
        ({ value, type = 'text', className, placeholder = '입력하세요.', disabled = false, label }, index) => {
          const privateKey = `${groupKey}-${index}`
          return (
            <li key={privateKey + index}>
              {label && <label htmlFor={`${groupKey}-${index}`}>{label}</label>}
              <input
                type={type}
                id={privateKey}
                name={privateKey}
                ref={(el) => (inputRef.current[index] = el)}
                value={inputState[index]}
                className={'input-text ' + className}
                defaultValue={value}
                placeholder={placeholder}
                disabled={disabled}
                onChange={(e) => handleChange(index, e.target.value)}
              />
            </li>
          )
        },
      )}
    </ul>
  )
}

export default Element
